import { motion } from 'framer-motion'
import { FileText } from 'lucide-react'

const RFQScreen = () => {
  return (
    <div className="min-h-screen bg-[var(--background)]">
      <div className="p-4 space-y-6">
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center py-8"
        >
          <h1 className="text-3xl font-bold text-[var(--text)] mb-2">Request for Quote</h1>
          <p className="text-[var(--text)] opacity-60">Browse and participate in RFQ opportunities</p>
        </motion.div>

        {/* Coming Soon */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="card text-center py-12"
        >
          <FileText size={48} className="mx-auto mb-4 text-[var(--text)] opacity-60" />
          <h3 className="text-xl font-semibold text-[var(--text)] mb-2">RFQ Coming Soon</h3>
          <p className="text-[var(--text)] opacity-60">Request for Quote functionality will be available soon</p>
        </motion.div>
      </div>
    </div>
  )
}

export default RFQScreen 